import AssignableUser, { AssignableUserProps } from './AssignableUser.component';

export type AssignableUserType = AssignableUserProps;

export default AssignableUser;
